module.exports = __webpack_public_path__ + "static/media/07-Köln@2x.d1bc7995.jpg";